import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { errorCatch, GET, JSXMap, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { getIndexColor, getIndexColorAlt, getIndexColorLighter, goTo } from '../../../../common/Tool';
import dayjs from 'dayjs';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
import { Selector } from 'antd-mobile';

const User = ({ user }) => {
	return (<div style={{
		border: "1px solid transparent",
		maxWidth: "208px",
		minWidth: "208px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ backgroundColor: (user?.genderID === 1) ? "blue" : "red", width: "13px", height: "13px", lineHeight: "13px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div>{user?.lastname} {user?.firstname}</div>
	</div>)
}
const UserDoubleLine = ({ user }) => {
	return (<div className='bg bg-grey' style={{
		textAlign: "left",
		border: "1px solid transparent",
		height: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ flex: "0 0 14px", backgroundColor: (user?.genderID === 1) ? "blue" : "red", height: "100%", lineHeight: "14px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div style={{ flex: "1 1 auto" }}>
			<div>{user?.lastname}</div>
			<div>{user?.firstname}</div>
		</div>
	</div>)
}
export default function EffektivnostSudeiDancer(props) {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();
	let navigate = useNavigate();

	const { auth } = props;
	const { dancertourid } = useParams();
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [protocolView, setProtocolView] = useState(true)

	const [data, setData] = useState()
	// "dancerTour"
	// "esItogPoSudyam"
	// "esItogPoKriteriyam"
	// "esOtsenkiSudey"

	useEffect(() => {
		setLoading(true);

		GET(auth, `/api/report/effektivnost-sudei-po-tantsoru/${dancertourid}`, ({ data }) => {
			data.criterionView = fillCriterion(data?.dancerTour.tour, data?.esItogPoKriteriyam);
			setData(data)
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth]);

	const fillCriterion = (tour, esItogPoKriteriyam) => {
		if (!tour || !esItogPoKriteriyam) {
			return [];
		}

		let criterionViewMap = {};

		for (let i = 0; i < esItogPoKriteriyam.length; i++) {
			let itogItem = esItogPoKriteriyam[i];

			//Убираем лишнии criterionLevel из критериев которые не соответствуют шаблону в туре
			//criterionLevel используется для расстановки критериев по приоритету
			if (itogItem?.parametrKriteriya?.criterion?.criterionLevel?.length) {
				itogItem.parametrKriteriya.criterion.criterionLevel = itogItem.parametrKriteriya.criterion.criterionLevel.filter((item) => item.templateID === tour.templateCloneID)
			}

			//-------------------------по критериям-------------------------
			//Критерий
			let criterion = itogItem?.parametrKriteriya?.criterion
			let criterionItem = criterionViewMap[criterion.ID] || {
				criterion: criterion,
				criterionParamsMap: {},
				criterionParams: [],
			}

			//Параметры критериев
			let criterionParams = itogItem?.parametrKriteriya
			let criterionParamsItem = criterionItem.criterionParamsMap[criterionParams.ID] || {
				criterionParams: criterionParams,
				protocolDancerParams: [],
			}
			criterionParamsItem.protocolDancerParams.push(itogItem);

			criterionItem.criterionParamsMap[criterionParams.ID] = criterionParamsItem
			criterionViewMap[criterion.ID] = criterionItem;
		}

		//Заполнение из map в массивы и сортировка
		let criterionViewRes = [];
		//Заполняем массив критериев
		//-------------------------по критериям-------------------------
		for (const criterionID in criterionViewMap) {
			if (Object.hasOwnProperty.call(criterionViewMap, criterionID)) {
				let criterionView = criterionViewMap[criterionID];
				criterionViewRes.push(criterionView);

				//Заполняем массив параметров
				for (const criterionParamsID in criterionView.criterionParamsMap) {
					if (Object.hasOwnProperty.call(criterionView.criterionParamsMap, criterionParamsID)) {
						let criterionParams = criterionView.criterionParamsMap[criterionParamsID];
						criterionView.criterionParams.push(criterionParams)
					}
				}

				//Сортируем параметры
				criterionView.criterionParams = criterionView?.criterionParams?.sort((a, b) => a.criterionParams.priorityInCriterion - b.criterionParams.priorityInCriterion)
			}
		}
		//Сортируем criterionView
		criterionViewRes = criterionViewRes?.sort((a, b) => a.criterion.criterionLevel[0].priority - b.criterion.criterionLevel[0].priority)

		return criterionViewRes;
	}

	const getTotal = (esItogPoKriteriyam, isSumm) => {
		let total = 0;
		for (let i = 0; i < esItogPoKriteriyam?.length; i++) {
			const itog = esItogPoKriteriyam[i];
			let val = itog?.srednee;
			if (isSumm) {
				val = itog?.summa;
			}
			total += val;
		}
		total = Math.round(total * 100) / 100;
		return total;
	}

	const ref = useRef(null)
	if (isDesktopOrLaptop || !isMobile) {
		return (
			<div>
				<div style={{ display: "flex", justifyContent: (data?.dancerTour ? "space-between" : "right"), padding: "15px 20px" }} >
					{(data?.dancerTour) && <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
						{(data?.dancerTour?.tourID) && <Button onClick={(e) => {
							navigate(`/app/reports/effektivnost-sudei/tour/${data?.dancerTour?.tourID}`);
						}}>Назад</Button>}
						<Button onClick={() => setProtocolView(!protocolView)}>{(protocolView) ? "Посмотреть дисперсию" : "Посмотреть оценки"}</Button>
					</div>}
					<ReactToPrint
						trigger={() => {
							// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
							// to the root node of the returned component as it will be overwritten.
							return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
						}}
						content={() => ref.current}
					/>
				</div>
				{(data?.esItogPoSudyam) && <div className="report" style={{ padding: "0 25px" }} ref={ref}>
					{(data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie) && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px" }}>
						<div>
							{(data.dancerTour?.dancerEvent?.tipTDID != 2) && <span style={{ fontWeight: "bold" }}>Участник №{data.dancerTour?.dancerEvent?.number}, {data.dancerTour?.dancerEvent?.user?.lastname} {data.dancerTour?.dancerEvent?.user?.firstname}</span>}
							{(data.dancerTour?.dancerEvent?.tipTDID == 2) && <div>
								<span style={{ fontWeight: "bold" }}>Пара №{data.dancerTour?.dancerEvent?.number}. {data.dancerTour?.dancerEvent?.user?.lastname} {data.dancerTour?.dancerEvent?.user?.firstname}, </span>
								<span style={{ fontWeight: "bold" }}>{data.dancerTour?.dancerEvent?.partner?.lastname} {data.dancerTour?.dancerEvent?.partner?.firstname}</span>
							</div>}
						</div>
						<div>
							<span>{data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ({data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.mestoProvedeniya?.name})
						</div>
						<div>
							<span>{data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}, </span>
							<span>{data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}, </span>
							<span>Тур №{data?.dancerTour?.tour?.number} ({data?.dancerTour?.tour?.tourType?.name})</span>
						</div>
					</div>}
					<div className='scrollable' style={{ backgroundColor: "white" }}>
						<table className="table" style={{ fontSize: "13px" }}>
							<thead>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "210px", backgroundColor: "white" }} rowSpan="2">
										<div className='bg bg-grey dark-1'>Судья</div>
									</th>
									<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px", backgroundColor: "white" }} rowSpan="2">
										<div className='bg bg-orange dark-5 border-orange'>Итого</div>
									</th>
									{JSXMap(data?.criterionView, (criterionItem, cidx) => {
										let color = getIndexColorLighter(cidx, 0.25);
										return (<th className="wrap" style={{ fontWeight: "300" }} key={cidx} colSpan={criterionItem?.criterionParams?.length}>
											<div className="bg bg-grey" style={{ backgroundColor: color }}>
												{criterionItem?.criterion?.name}
											</div>
										</th>)
									})}
								</tr>
								<tr>
									{JSXMap(data?.criterionView, (criterionItem, cidx) =>
										<React.Fragment key={cidx}>
											{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
												let color = getIndexColorLighter(cidx, 0.20);
												return (<th className="wrap" key={cxidx}>
													<div className="bg bg-grey" style={{ backgroundColor: color }}>
														{param?.criterionParams?.name}
													</div>
												</th>)
											})}
										</React.Fragment>
									)}
								</tr>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange'>Сумма</div>
									</th>
									<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-1 border-orange' style={{ fontWeight: "bold" }}>
											{getTotal(data?.esItogPoKriteriyam, true)}
										</div>
									</th>
									{JSXMap(data?.criterionView, (criterionItem, cidx) =>
										<React.Fragment key={cidx}>
											{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
												// let color = getIndexColorLighter(cidx, 0.14);

												let itemCell = data?.esItogPoKriteriyam?.find((el) => {
													return el?.parametrKriteriyaID == param?.criterionParams?.ID
												})

												let val = itemCell?.summa;

												return (<th className="wrap" key={cxidx}>
													<div className="bg bg-orange dark-1 border-orange" style={{ fontWeight: "bold" }}>
														{(val) ? val : ""}
													</div>
												</th>)
											})}
										</React.Fragment>
									)}
								</tr>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange'>Среднее значение</div>
									</th>
									<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-1 border-orange' style={{ fontWeight: "bold" }}>
											{getTotal(data?.esItogPoKriteriyam, false)}
										</div>
									</th>
									{JSXMap(data?.criterionView, (criterionItem, cidx) =>
										<React.Fragment key={cidx}>
											{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
												// let color = getIndexColorLighter(cidx, 0.14);

												let itemCell = data?.esItogPoKriteriyam?.find((el) => {
													return el?.parametrKriteriyaID == param?.criterionParams?.ID
												})

												let val = itemCell?.srednee;

												return (<th className="wrap" key={cxidx}>
													<div className="bg bg-orange dark-1 border-orange" style={{ fontWeight: "bold" }}>
														{(val) ? val : ""}
													</div>
												</th>)
											})}
										</React.Fragment>
									)}
								</tr>
							</thead>
							<tbody style={{ fontSize: "12px" }}>
								{JSXMap(data?.esItogPoSudyam || [], (judgeItem, cidx) => {

									return (<tr key={cidx}>
										<td className={`fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
											<User user={judgeItem?.sudya?.user} />
										</td>
										<td className={`fixed`} style={{ left: "210px", minWidth: "70px", maxWidth: "70px", backgroundColor: "white" }}>
											<div className="bg bg-orange dark-1" style={{ fontWeight: "bold" }}>
												{(protocolView) ? judgeItem?.summaPoOtsenkam : judgeItem?.sredneePoDispersiyam}
											</div>
										</td>
										{JSXMap(data?.criterionView, (criterionItem, cidx) =>
											<React.Fragment key={cidx}>
												{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
													let color = getIndexColorLighter(cidx, 0.14);

													let itemCell = data?.esOtsenkiSudey?.find((el) => {
														return el?.sudyaID == judgeItem?.sudyaID &&
															el?.parametrKriteriyaID == param?.criterionParams?.ID
													})

													let val = itemCell?.dispersiya;
													if (protocolView) {
														val = itemCell?.znachenie;
													}

													return (<th className="wrap" key={cxidx}>
														<div className="bg bg-grey" style={{ backgroundColor: color }}>
															{val}
														</div>
													</th>)
												})}
											</React.Fragment>
										)}
									</tr>)
								})}
							</tbody>
						</table>
					</div>
				</div>}
			</div >);
	} else {
		return (
			<div>
				<div style={{ display: "flex", justifyContent: (data?.dancerTour ? "space-between" : "right"), padding: "15px 10px" }} >
					{(data?.dancerTour) && <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
						{(data?.dancerTour?.tourID) && <Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }} onClick={(e) => {
							navigate(`/app/reports/effektivnost-sudei/tour/${data?.dancerTour?.tourID}`);
						}}><i className='fa fa-chevron-left'></i></Button>}
					</div>}
					<ReactToPrint
						trigger={() => {
							// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
							// to the root node of the returned component as it will be overwritten.
							return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /></Button>)
						}}
						content={() => ref.current}
					/>
				</div>
				{(data?.esItogPoSudyam) && <div className="report" style={{ padding: "0 5px" }} ref={ref}>
					{(data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie) && <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px" }}>
						<div>
							<span>{data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nazvanieMeropriyatiya}</span>
						</div>
						<div>
							{dayjs(data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ({data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.mestoProvedeniya?.name})
						</div>
						<div style={{ fontSize: "14px" }}>
							<span>{data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}, </span>
							<span>{data?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}, </span>
							<div>Тур №{data?.dancerTour?.tour?.number} ({data?.dancerTour?.tour?.tourType?.name})</div>
						</div>
						<div style={{ fontSize: "14px" }}>
							{(data.dancerTour?.dancerEvent?.tipTDID != 2) && <span style={{ fontWeight: "bold" }}>Участник №{data.dancerTour?.dancerEvent?.number}, {data.dancerTour?.dancerEvent?.user?.lastname} {data.dancerTour?.dancerEvent?.user?.firstname}</span>}
							{(data.dancerTour?.dancerEvent?.tipTDID == 2) && <div>
								<div>
									<span style={{ fontWeight: "bold" }}>Пара №{data.dancerTour?.dancerEvent?.number}. {data.dancerTour?.dancerEvent?.user?.lastname} {data.dancerTour?.dancerEvent?.user?.firstname}, </span>
								</div>
								<div>
									<span style={{ fontWeight: "bold" }}>{data.dancerTour?.dancerEvent?.partner?.lastname} {data.dancerTour?.dancerEvent?.partner?.firstname}</span>
								</div>
							</div>}
						</div>
					</div>}
					<div style={{ padding: "5px 0" }}>
						<Selector
							columns={2}
							options={[
								{
									label: 'Оценки',
									value: '1',
								},
								{
									label: 'Дисперсия',
									value: '2',
								},
							]}
							value={[(protocolView) ? "1" : "2"]}
							onChange={(arr, extend) => setProtocolView(arr[0] == '1')}
						/>
					</div>
					<div className='scrollable' style={{ backgroundColor: "white" }}>
						<table className="table" style={{ fontSize: "13px" }}>
							<thead>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "100px", backgroundColor: "white" }} rowSpan="2">
										<div className='bg bg-grey dark-1'>Судья</div>
									</th>
									<th className="wrap fixed" style={{ left: "100px", minWidth: "48px", backgroundColor: "white" }} rowSpan="2">
										<div className='bg bg-orange dark-5 border-orange'>Итого</div>
									</th>
									{JSXMap(data?.criterionView, (criterionItem, cidx) => {
										let color = getIndexColorLighter(cidx, 0.25);
										return (<th className="wrap" style={{ fontWeight: "300", minWidth: "48px" }} key={cidx} colSpan={criterionItem?.criterionParams?.length}>
											<div className="bg bg-grey" style={{ backgroundColor: color }}>
												{criterionItem?.criterion?.name?.slice(0, 3)}.
											</div>
										</th>)
									})}
								</tr>
								<tr>
									{JSXMap(data?.criterionView, (criterionItem, cidx) =>
										<React.Fragment key={cidx}>
											{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
												let color = getIndexColorLighter(cidx, 0.20);
												return (<th className="wrap" key={cxidx} style={{ minWidth: "48px" }}>
													<div className="bg bg-grey" style={{ backgroundColor: color, minWidth: "48px" }}>
														{param?.criterionParams?.name?.slice(0, 3)}.
													</div>
												</th>)
											})}
										</React.Fragment>
									)}
								</tr>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange'>Сумма</div>
									</th>
									<th className="wrap fixed" style={{ left: "100px", minWidth: "48px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-1 border-orange' style={{ fontWeight: "bold" }}>
											{getTotal(data?.esItogPoKriteriyam, true)}
										</div>
									</th>
									{JSXMap(data?.criterionView, (criterionItem, cidx) =>
										<React.Fragment key={cidx}>
											{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
												// let color = getIndexColorLighter(cidx, 0.14);

												let itemCell = data?.esItogPoKriteriyam?.find((el) => {
													return el?.parametrKriteriyaID == param?.criterionParams?.ID
												})

												let val = itemCell?.summa;

												return (<th className="wrap" key={cxidx} style={{ minWidth: "48px" }}>
													<div className="bg bg-orange dark-1 border-orange" style={{ fontWeight: "bold" }}>
														{(val) ? val : ""}
													</div>
												</th>)
											})}
										</React.Fragment>
									)}
								</tr>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange'>Среднее</div>
									</th>
									<th className="wrap fixed" style={{ left: "100px", minWidth: "48px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-1 border-orange' style={{ height: "100%", fontWeight: "bold" }}>
											{getTotal(data?.esItogPoKriteriyam, false)}
										</div>
									</th>
									{JSXMap(data?.criterionView, (criterionItem, cidx) =>
										<React.Fragment key={cidx}>
											{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
												// let color = getIndexColorLighter(cidx, 0.14);

												let itemCell = data?.esItogPoKriteriyam?.find((el) => {
													return el?.parametrKriteriyaID == param?.criterionParams?.ID
												})

												let val = itemCell?.srednee;

												return (<th className="wrap" key={cxidx} style={{ minWidth: "48px" }}>
													<div className="bg bg-orange dark-1 border-orange" style={{ height: "100%", fontWeight: "bold" }}>
														{(val) ? val : ""}
													</div>
												</th>)
											})}
										</React.Fragment>
									)}
								</tr>
							</thead>
							<tbody style={{ fontSize: "12px" }}>
								{JSXMap(data?.esItogPoSudyam || [], (judgeItem, cidx) => {

									return (<tr key={cidx}>
										<td className={`fixed`} style={{ minWidth: "100px", backgroundColor: "white", height: "40px" }}>
											<UserDoubleLine user={judgeItem?.sudya?.user} />
										</td>
										<td className={`fixed`} style={{ left: "100px", minWidth: "48px", backgroundColor: "white", height: "40px" }}>
											<div className="bg bg-orange dark-1" style={{ height: "100%", fontWeight: "bold" }}>
												{(protocolView) ? judgeItem?.summaPoOtsenkam : judgeItem?.sredneePoDispersiyam}
											</div>
										</td>
										{JSXMap(data?.criterionView, (criterionItem, cidx) =>
											<React.Fragment key={cidx}>
												{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
													let color = getIndexColorLighter(cidx, 0.14);

													let itemCell = data?.esOtsenkiSudey?.find((el) => {
														return el?.sudyaID == judgeItem?.sudyaID &&
															el?.parametrKriteriyaID == param?.criterionParams?.ID
													})

													let val = itemCell?.dispersiya;
													if (protocolView) {
														val = itemCell?.znachenie;
													}

													return (<td className="wrap" key={cxidx} style={{ minWidth: "48px", height: "40px" }}>
														<div className="bg bg-grey" style={{ height: "100%", backgroundColor: color }}>
															{val}
														</div>
													</td>)
												})}
											</React.Fragment>
										)}
									</tr>)
								})}
							</tbody>
						</table>
					</div>
				</div>}
			</div >);
	}
}
